import { useStarredEntities } from '@backstage/plugin-catalog-react';
import { HomePageStarredEntities } from '@backstage/plugin-home';
import { Button, Popover, makeStyles } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import StarIcon from '@material-ui/icons/Star';
import { MouseEvent, useState } from 'react';

const useStyles = makeStyles(theme => ({
  paper: {
    width: 440,
    maxWidth: 'calc(100vw - 32px)',
    maxHeight: '70vh',
    marginTop: theme.spacing(1),
  },
}));

export interface FavoritesMenuProps {
  className?: string;
}

/**
 * Button that opens the user's starred catalog entities in a dropdown,
 * replacing the full-size Favorites card on the home page.
 */
export const FavoritesMenu = ({ className }: FavoritesMenuProps) => {
  const classes = useStyles();
  const { starredEntities } = useStarredEntities();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  return (
    <>
      <Button
        className={className}
        variant="outlined"
        startIcon={<StarIcon />}
        endIcon={<ArrowDropDownIcon />}
        onClick={(event: MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)}
        aria-haspopup="true"
        aria-expanded={open}
        aria-controls={open ? 'devhub-favorites-menu' : undefined}
      >
        Favorites ({starredEntities.size})
      </Button>
      <Popover
        id="devhub-favorites-menu"
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ className: classes.paper }}
      >
        <HomePageStarredEntities title="Favorites" />
      </Popover>
    </>
  );
};
